export default "__VITE_ASSET__D_loWD0S__"